import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_y2j497tv82: FaireBrandEntity = {
  token: "b_y2j497tv82",
  type: "brand",
  name: "The Pretty Jewellery",
  avatarUrl:
    "https://cdn.faire.com/fastly/f7001af1597c4502236adf4e4245e344bbbd34ace0973714118b275e2e64d902.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7d06e643735f0e5e091f689de34f228438d41ce3d4bc6bee008da3a7824162db.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f7001af1597c4502236adf4e4245e344bbbd34ace0973714118b275e2e64d902.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7d06e643735f0e5e091f689de34f228438d41ce3d4bc6bee008da3a7824162db.jpeg",
  location: "Olympia, WA, USA",
  minimumOrderDollars: 68,
  rating: 4.8,
  reviewCount: 305,
  isTopShop: true,
  isInsider: true,
  description:
    "The_ Pretty_ Jewellery was founded in 2021 and believes that women deserve to be treated well. We strive to make our works of art amazing, which is regarded by many as an important tool to enhance confidence, so that women can face life in the most perfect and beautiful state.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:05.780Z",
    importedBy: "entity-db-cli",
  },
};
